import app from '@/main'
import * as moment from 'moment'

const desktopModule = {
  namespaced: true,
  state: {
    updatedTime: new Date().getTime(),
    salesFunnel: {
      period: {
        start: new Date(
          moment()
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .subtract(6, 'days')
            .format()
        ).getTime(),
        end: new Date(moment().set({ hour: 23, minute: 59, second: 0, millisecond: 0 })).getTime()
      },
      loading: false,
      data: null
    },
    visits: {
      request_params: {
        start: new Date(
          moment()
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .subtract(6, 'days')
            .format()
        ).getTime(),
        end: new Date(moment().set({ hour: 23, minute: 59, second: 0, millisecond: 0 })).getTime(),
        source: 'all',
        condition: 'visits'
      },
      loading: false,
      data: null,
      total_per_period: null
    },
    orders: null
  },

  getters: {
    // needUpdateData(state, getters) {
    //   if (!getters.dataExist) return true
    //   console.log(new Date().getTime() - state.updatedTime)
    //   return new Date().getTime() - state.updatedTime > 30000
    // },
    dataExist(state) {
      return state.salesFunnel.data && state.visits.data
    },
    getAllOrders(state) {
      return state.orders
    }
  },

  mutations: {
    setUpdatedTime: (state, time) => (state.updatedTime = time),
    setSalesFunnelData: (state, data) => (state.salesFunnel.data = data),
    setSalelFunnelLoading: (state, loading) => (state.salesFunnel.loading = loading),
    setVisitsData: (state, data) => (state.visits.data = data),
    setVisitsTotalPerPeriod: (state, total_per_period) => (state.visits.total_per_period = total_per_period),
    setVisitsLoading: (state, loading) => (state.visits.loading = loading),
    setOrders: (state, orders) => {
      state.orders = orders
    }
  },

  actions: {
    GET_VISITS_ANALYTICS: async ({ dispatch, commit, state, rootState }, needUpdate) => {
      if (state.visits.loading) return
      if (
        rootState.analytics.visits.first.data &&
        rootState.analytics.visits.first.request_params.start ===
          state.visits.request_params.start &&
        rootState.analytics.visits.first.request_params.end === state.visits.request_params.end &&
        !needUpdate
      )
        return (
          commit('setVisitsData', rootState.analytics.visits.first.data),
          commit('setVisitsTotalPerPeriod', rootState.analytics.visits.first.total_per_period)
        )

      if (
        rootState.analytics.visits.second.data &&
        rootState.analytics.visits.second.request_params.start ===
          state.visits.request_params.start &&
        rootState.analytics.visits.second.request_params.end === state.visits.request_params.end &&
        !needUpdate
      )
        return (
          commit('setVisitsData', rootState.analytics.visits.second.data),
          commit('setVisitsTotalPerPeriod', rootState.analytics.visits.second.total_per_period)
        )

      commit('setVisitsLoading', true)

      try {
        const response = await dispatch(
          'analytics/visits/FETCH_VISITS_ANALYTICS',
          state.visits.request_params,
          { root: true }
        )
        commit('setVisitsData', response.visits)
        commit('setVisitsTotalPerPeriod', response.total_per_period)
        commit('setVisitsLoading', false)
      } catch (e) {
        app.$raven.captureException(new Error('Error - store/desktop, GET_VISITS_ANALYTICS'), {
          extra: e,
          tags: {
            component: 'store/desktop',
            method: 'GET_VISITS_ANALYTICS'
          }
        })

        app.$message('danger', e.statusText || 'Error')
      }
    },
    GET_SALES_FUNNEL_ANALYTICS: async ({ dispatch, commit, state, rootState }, needUpdate) => {
      if (state.salesFunnel.loading) return
      if (
        rootState.analytics.salesFunnel.data &&
        rootState.analytics.salesFunnel.period.start === state.salesFunnel.period.start &&
        rootState.analytics.salesFunnel.period.end === state.salesFunnel.period.end &&
        !needUpdate
      )
        return commit('setSalesFunnelData', rootState.analytics.salesFunnel.data)

      commit('setSalelFunnelLoading', true)

      try {
        const data = await dispatch(
          'analytics/salesFunnel/FETCH_SALES_FUNNEL_ANALYTICS',
          state.salesFunnel.period,
          { root: true }
        )
        commit('setSalesFunnelData', data)
        commit('setSalelFunnelLoading', false)
      } catch (e) {
        app.$raven.captureException(
          new Error('Error - store/desktop, GET_SALES_FUNNEL_ANALYTICS'),
          {
            extra: e,
            tags: {
              component: 'store/desktop',
              method: 'GET_SALES_FUNNEL_ANALYTICS'
            }
          }
        )

        app.$message('danger', e.statusText || 'Error')
      }
    }
  }
}

export default desktopModule



// WEBPACK FOOTER //
// ./src/store/modules/desktop.js